import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 61,
  label: "发明人排行榜",
  chart: charts.lineAndBar,
  definition: {
    rowDims: [{
      name: "inventorNewName",
      label: "发明人",
      table: "patent_inventor",
      limit: 10,
      needTotal: true
    }],
    colDims: [],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    showNoDataDims: true
  },
  chartOption: {
    chartType: ChartType.BAR,
    title: "发明人排行榜",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: false,
    hideLegend: false,
    hideToolbox: false
  }
};
